import {InjectionToken, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import {DatePipe, registerLocaleData} from '@angular/common';

import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {AppComponent} from './components/app/app.component';
import {CoreRoutingModule} from './core-routing.module';
import {SharedModule} from '../shared/shared.module';
import {AuthModule} from '../auth/auth.module';
import {environment} from '../../../environments/environment';
import {UserModule} from '../user/user.module';
import {NavigationComponent} from './components/navigation/navigation.component';
import {HeaderComponent} from './components/header/header.component';
import {FooterComponent} from './components/footer/footer.component';
import {tokenInterceptor} from '../auth/interceptors/token.interceptor';
import {InspectionModule} from "../inspection/inspection.module";
import {LocaleService} from "../shared/services/locale.service";

export function createTranslateLoader(http: HttpClient) {
    // Utiliser l'URL du backend pour les traductions
    return new TranslateHttpLoader(http, `${environment.api.host}/locales/`, '.json');
}

export function localeIdFactory(localeService: LocaleService): string {
    return localeService.getLocale();
}

registerLocaleData(localeFr);

export const OAUTH2_PROVIDERS_URL = new InjectionToken<string>('OAUTH2_PROVIDERS_URL');
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const LOADER_ON_HTTP = new InjectionToken<string>('LOADER_ON_HTTP');

@NgModule({
    declarations: [AppComponent, NavigationComponent, HeaderComponent, FooterComponent],
    imports: [
        // Angular packages
        BrowserModule,
        BrowserAnimationsModule,
        CoreRoutingModule,

        // Plugins packages
        TranslateModule.forRoot({
            defaultLanguage: 'fr',
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),

        // App packages
        SharedModule,
        AuthModule,
        UserModule,
        InspectionModule
    ],
    providers: [
        provideHttpClient(withInterceptors([tokenInterceptor]), withInterceptorsFromDi()),
        provideAnimationsAsync(),
        {provide: 'OAUTH2_PROVIDERS_URL', useValue: environment.api.providers},
        {provide: 'API_BASE_URL', useValue: environment.api.host},
        {provide: 'LOADER_ON_HTTP', useValue: environment.loaderOnHttp},
        DatePipe,
        LocaleService,
        {
            provide: LOCALE_ID,
            useFactory: localeIdFactory,
            deps: [LocaleService]
        },
    ],
    bootstrap: [AppComponent],
})
export class CoreModule {
}
